import Vue from "vue";
import { VTab, VueTabs } from "vue-nav-tabs";

Vue.component("vue-tabs", VueTabs);
Vue.component("v-tab", VTab);

import buttonScComponent from "@/components/child/form/buttonSc.vue";
import checkboxComponent from "@/components/child/form/checkbox.vue";
import dateTimePickerComponent from "@/components/child/form/datetimepicker.vue";
import fieldsetComponent from "@/components/child/form/fieldset.vue";
import moedaComponent from "@/components/child/form/moeda.vue";
import gridComponent from "@/components/child/grid/grid.vue";
import { Component, Prop } from "@/decorators";
import SituacoesVenda from "@/models/enum/situacoesVenda";
import VendaModel from "@/models/vendaModel";
import Bus from "@/utils/events/bus";

import VendaComponent from "./vendaForm";
import vendaComponent from "./vendaForm.vue";

import "../crud/crud.scss";
import "./../../../../node_modules/vue-nav-tabs/themes/vue-tabs.css";
import "./edit.scss";

@Component({
    components: {
        fieldsetComponent,
        dateTimePickerComponent,
        moedaComponent,
        gridComponent,
        checkboxComponent,
        vendaComponent,
        buttonScComponent,
    },
})
export default class PreVendaEditComponent extends Vue {
    // State computed props

    private preVendaComponent: VendaComponent = null;
    motivoCancelamentoOptions: Array<Object> = [];

    //title, Id da tabela e o codigo da ordem
    private etapasPreVenda = new Array<[string, number, string, object]>();
    private tabs = new Array<string>();
    activeTab = "";

    private paramEnderecoEntregaId: number = null;
    private paramPacienteId: number = null;
    private paramOrigem: number = null;

    it = "1";

    //string pq eh o que o paramentro aceita
    @Prop(String) clienteId: string;
    private numClienteId = 0;

    onAddTab() {
        const etapaPreVenda: [string, number, string, object] = ["Nova Pré-Venda **", 0, this.it, null];
        this.etapasPreVenda.push(etapaPreVenda);
        this.tabs.push(this.it);

        this.it = this.incrementarCodigo(this.it);
    }

    //nao pode ser parametro para a funcao acima pq a funcao ganha parametros de clicks da tela
    private async onReplicarPreVenda(model: VendaModel) {
        const etapaVenda: [string, number, string, object] = ["Nova Pré-Venda **", 0, this.it, model];
        this.etapasPreVenda.push(etapaVenda);
        this.tabs.push(this.it);

        this.it = this.incrementarCodigo(this.it);
    }

    onRemoveTab(num: number, validarStopProp = true) {
        if (this.etapasPreVenda.length == 1) {
            this.$router.back();
        } else {
            let stopProp = true;
            if (num == 0 && this.etapasPreVenda.length > 2) {
                this.activeTab = this.etapasPreVenda[1][0] + this.etapasPreVenda[1][2];
            } else if (num > 0) {
                this.activeTab = this.etapasPreVenda[num - 1][0] + this.etapasPreVenda[num - 1][2];
            } else {
                stopProp = false;
            }
            this.etapasPreVenda.splice(num, 1);
            this.tabs.splice(num, 1);

            if (stopProp && validarStopProp) {
                window.event.stopPropagation();
            }
        }
    }

    private onLoadedNewVenda(index: number) {
        if (index > 0) {
            this.activeTab = "Nova Pré-Venda **" + this.etapasPreVenda[index][2];
        }
    }

    private async onEditVenda(model: VendaModel, index) {
        let title = this.getTitleBySituacao(model.situacao);

        title += " " + (model.id == null ? "Novo **" : "Cód:");
        const idPreVenda = model.id == null ? 0 : model.id;
        const etapaPreVenda: [string, number, string, object] = [
            title,
            idPreVenda,
            model.id == null ? this.etapasPreVenda[index][2].toString() : model.codigo,
            null,
        ];
        this.$set(this.etapasPreVenda, index, etapaPreVenda);

        //sempre q chega aqui com id null eh orçamento novo ? por enquanto eh
        if (model.id == null) {
            this.activeTab = title + this.etapasPreVenda[index][2];
        }
    }

    private onChangedVenda(model: VendaModel, index: number) {
        let title = this.getTitleBySituacao(model.situacao);

        title += " " + (model.id == null ? "Novo **" : "Cód:");

        const idVenda = model.id == null ? 0 : model.id;
        const etapaVenda: [string, number, string, object] = [
            title,
            idVenda,
            model.id == null ? this.etapasPreVenda[index][2].toString() : model.codigo,
            null,
        ];
        this.$set(this.etapasPreVenda, index, etapaVenda);
    }

    private getTitleBySituacao(situacao: SituacoesVenda) {
        switch (situacao) {
            case SituacoesVenda.PreVenda:
                return "Pré-Venda";
            case SituacoesVenda.PreRecebimento:
                return "Pré-Recebimento";
            default:
                return "Pré-Venda";
        }
    }

    private beforeDestroy() {
        this.clearAll();
    }

    private clearAll() {
        this.preVendaComponent = null;
        this.etapasPreVenda = null;
    }

    private async mounted() {
        this.preVendaComponent = this.$refs.preVendaComponent as VendaComponent;
        Bus.$emit("hide-nav-menu", true);

        this.paramEnderecoEntregaId = null;
        this.paramPacienteId = null;
        this.paramOrigem = null;

        if (this.$route.query.clienteId != null) {
            //@ts-ignore
            this.numClienteId = parseInt(this.$route.query.clienteId);

            this.paramOrigem = 5; // 5 É o ID da origem 'Aplicativo'
        }

        if (this.$route.query.enderecoEntregaId != null) {
            //@ts-ignore
            this.paramEnderecoEntregaId = parseInt(this.$route.query.enderecoEntregaId);
        }

        if (this.$route.query.pacienteId != null) {
            //@ts-ignore
            this.paramPacienteId = parseInt(this.$route.query.pacienteId);
        }

        if (this.$route.query.origem != null) {
            //@ts-ignore
            this.paramOrigem = parseInt(this.$route.query.origem);
        }

        if (this.clienteId != null && this.clienteId != "") {
            this.numClienteId = parseInt(this.clienteId);
        }

        let x: [string, number, string, object];

        if (this.$route.params.id) {
            x = ["Pré-Venda cód:", +this.$route.params.id, "0", null];
        } else {
            x = ["Nova Pré-Venda **", 0, "0", null];
        }

        this.etapasPreVenda.push(x);
        this.tabs.push("0");
    }

    private incrementarCodigo(codigo: string): string {
        // Captura prefixo (letras e símbolos) e o número final
        const match = codigo.match(/^([^\d]*)(\d+)$/);

        if (!match) {
            // Se não tiver número, começa com 1
            return codigo + "1";
        }

        const prefixo = match[1];
        const numero = parseInt(match[2], 10) + 1;

        // Mantém o mesmo número de dígitos (ex: BAL-001 → BAL-002)
        const numeroFormatado = match[2].replace(/\d+/, numero.toString().padStart(match[2].length, "0"));

        return prefixo + numeroFormatado;
    }
}
